import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  TextField,
  Grid,
  CircularProgress,
  useMediaQuery,
  useTheme,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/Header";
import {
  updateChapaDesc,
  getOnePaquetexd,
  getVaciarChapa,
} from "../../services/cargadora.services";
import { getOne } from "../../services/stock.services";
import { getProduccionView } from "../../services/lavadoraSocket.services";

const validationSchema = yup.object({
  cod_interno: yup.string().required("El paquete es requerido"),
  orden: yup.string().required("La orden es requerida"),
  cantidad: yup
    .number()
    .required("La cantidad es requerida")
    .min(1, "Debe ser al menos 1"),
  chapa1: yup.boolean(),
  chapa2: yup.boolean(),
});

const FormChapas = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [ordenes, setOrdenes] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  // 🔹 Traer datos al montar
  useEffect(() => {
    const fetchData = async () => {
      try {
        const datos = await getProduccionView();
        const filteredData = datos.filter(
          (item) => item.Estado == "en proceso"
        );
        setOrdenes(filteredData);
      } catch (error) {
        console.error("Error al obtener datos del backend:", error);
        toast.error("Error al cargar órdenes de producción");
      }
    };
    fetchData();
  }, []);

  const formik = useFormik({
    initialValues: {
      orden: "",
      cod_interno: "",
      cantidad: 1,
      chapa1: false,
      chapa2: false,
      cod: "",
      llave: "", 
      restante: "", 
    },
    validationSchema,

    // onSubmit: async (values, { resetForm }) => {
    //   setIsLoading(true);

    //   try {
    //     // 🔹 Traigo los datos del paquete (stock real)
    //     const datosPaquete = await getOne(values.cod_interno);
    //     // 🔹 Traigo los datos de la orden (paquete esperado en chapas)
    //     const paquete = await getOnePaquetexd(values.cod);
    //     // 1️⃣ Validación: al menos una chapa seleccionada
    //     if (!values.chapa1 && !values.chapa2) {
    //       toast.error("Debe seleccionar al menos una chapa");
    //       setIsLoading(false);
    //       return;
    //     }

    //     if (values.chapa1 && values.chapa2) {
    //       values.restante = values.restante * 2;
    //     }
    //     // 2️⃣ Validación: cantidad disponible
    //     if (values.cantidad > (datosPaquete.cantidad_entrada-datosPaquete.reservado)) {
    //       toast.error(
    //         `El Paquete solo cuenta con ${(datosPaquete.cantidad_entrada-datosPaquete.reservado)} chapas disponibles sin reservar`
    //       );
    //       setIsLoading(false);
    //       return;
    //     }
    //     if (values.cantidad > values.restante) {
    //       toast.error(
    //         `La orden solo cuenta con ${values.restante} chapas restantes por producir`
    //       );
    //       setIsLoading(false);
    //       return;
    //     }
    //     // 3️⃣ Validaciones de coincidencia entre chapa y paquete
    //     if (values.chapa1 && datosPaquete.cod !== paquete.paquete2) {
    //       toast.error(
    //         "El código del paquete no coincide con el producto a procesar"
    //       );
    //       setIsLoading(false);
    //       return;
    //     }
    //     if (values.chapa2 && datosPaquete.cod !== paquete.paquete3) {
    //       toast.error(
    //         "El código del paquete no coincide con el producto a procesar"
    //       );
    //       setIsLoading(false);
    //       return;
    //     }
    //     if (values.chapa1 && values.chapa2) {
    //       if (
    //         datosPaquete.cod !== paquete.paquete2 &&
    //         datosPaquete.cod !== paquete.paquete3
    //       ) {
    //         toast.error(
    //           "El código del paquete no coincide con el producto a procesar"
    //         );
    //         setIsLoading(false);
    //         return;
    //       }
    //     }
    //     // 🔹 Datos a enviar al backend
    //     const valuesToSend = {
    //       cod_interno: values.cod_interno,
    //       cantidad: values.cantidad,
    //       chapa1: values.chapa1,
    //       chapa2: values.chapa2,
    //     };
    //     await updateChapaDesc(values.orden, valuesToSend);
    //     toast.success(
    //       `Se asignó el paquete ${values.cod_interno} en ${
    //         values.chapa1 && values.chapa2
    //           ? "Chapa 1 y Chapa 2"
    //           : values.chapa1
    //           ? "Chapa 1"
    //           : "Chapa 2"
    //       } para la orden ${values.orden}`,
    //       { position: "top-center", autoClose: 5000 }
    //     );
    //     resetForm();
    //   } catch (error) {
    //     toast.error(error.message || "Error al actualizar chapa", {
    //       position: "top-center",
    //       autoClose: 5000,
    //     });
    //   } finally {
    //     setIsLoading(false);
    //   }
    // },

    onSubmit: async (values, { resetForm }) => {
       console.log("📋 values:", values);
  setIsLoading(true);

  try {
    // 🔹 Traigo los datos del paquete (stock real)
    const datosPaquete = await getOne(values.cod_interno);
    console.log("🔹 datosPaquete:", datosPaquete);
    // 🔹 Traigo los datos de la orden (paquete esperado en chapas)
    const paquete = await getOnePaquetexd(values.cod, values.llave);
    console.log("🚀 ~ FormChapas ~ values.llave:", values.llave)
    console.log("🔹 paquete (orden):", paquete);

if (values.llave_producto === 0) {
  // Llave 0: coincidencia EXACTA (proveedor específico)
  const codPaquete = datosPaquete.cod;
  const coincideChapa1 = !values.chapa1 || codPaquete === paquete.paquete2;
  const coincideChapa2 = !values.chapa2 || codPaquete === paquete.paquete3;

  if (!coincideChapa1 || !coincideChapa2) {
    toast.error(
      `El paquete no coincide. Se requieren: ${paquete.paquete2} y ${paquete.paquete3}`,
      { position: "top-center", autoClose: 6000 }
    );
    setIsLoading(false);
    return;
  }

} else if (values.llave_producto === 1) {
   const sinPrefijo = (cod) => /^[A-Z]-/.test(cod) ? cod.slice(2) : cod; // ✅ genérico

  const codSinPrefijo = sinPrefijo(datosPaquete.cod);
  const paquete2SinPrefijo = sinPrefijo(paquete.paquete2); // 👈 también al paquete
  const paquete3SinPrefijo = sinPrefijo(paquete.paquete3); // 👈 también al paquete

  const coincideChapa1 = !values.chapa1 || (paquete2SinPrefijo && codSinPrefijo.includes(paquete2SinPrefijo));
  const coincideChapa2 = !values.chapa2 || (paquete3SinPrefijo && codSinPrefijo.includes(paquete3SinPrefijo));
  if (!coincideChapa1 || !coincideChapa2) {
    toast.error(
      `El paquete no coincide. Se requieren: ${paquete2SinPrefijo} y ${paquete3SinPrefijo}`,
      { position: "top-center", autoClose: 6000 }
    );
    setIsLoading(false);
    return;
  }
}


    // 1️⃣ Validación: al menos una chapa seleccionada
    if (!values.chapa1 && !values.chapa2) {
      toast.error("Debe seleccionar al menos una chapa");
      setIsLoading(false);
      return;
    }

    if (values.chapa1 && values.chapa2) {
      values.restante = values.restante * 2;
    }

    // 2️⃣ Validación: cantidad disponible
    if (values.cantidad > (datosPaquete.cantidad_entrada - datosPaquete.reservado)) {
      toast.error(
        `El paquete solo cuenta con ${
          datosPaquete.cantidad_entrada - datosPaquete.reservado
        } chapas disponibles sin reservar`
      );
      setIsLoading(false);
      return;
    }

    if (values.cantidad > values.restante) {
      toast.error(
        `La orden solo cuenta con ${values.restante} chapas restantes por producir`
      );
      setIsLoading(false);
      return;
    }

    // 🔹 Datos a enviar al backend
    const valuesToSend = {
      cod_interno: values.cod_interno,
      cantidad: values.cantidad,
      chapa1: values.chapa1,
      chapa2: values.chapa2,
      llave: values.llave,
  cod: values.cod
    };
    console.log("🚀 ~ FormChapas ~ valuesToSend:", valuesToSend)

    await updateChapaDesc(values.orden, valuesToSend);

    toast.success(
      `Se asignó el paquete ${values.cod_interno} en ${
        values.chapa1 && values.chapa2
          ? "Chapa 1 y Chapa 2"
          : values.chapa1
          ? "Chapa 1"
          : "Chapa 2"
      } para la orden ${values.orden}`,
      { position: "top-center", autoClose: 5000 }
    );

    resetForm();
  } catch (error) {
    toast.error(error.message || "Error al actualizar chapa", {
      position: "top-center",
      autoClose: 5000,
    });
  } finally {
    setIsLoading(false);
  }
},

  });

  return (
    <Box m="20px">
      <Header
        title="Asignación de Chapas"
        subtitle="Ocupar chapas con paquetes"
      />
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={4}>
          {/* 🔹 Orden como Select */}
          <Grid item xs={12}>
            {/* <TextField
              fullWidth
              select
              variant="outlined"   // 👈 asegura que use el mismo estilo
              size="medium"        // 👈 mantiene misma altura
              label="Seleccione la Orden"
              name="orden"
              value={formik.values.orden}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.orden && Boolean(formik.errors.orden)}
              helperText={formik.touched.orden && formik.errors.orden}
              sx={{ minWidth: "300px", flex: 1 }}  // 👈 fuerza ancho mayor

            >
              {ordenes.map((orden) => (
                <MenuItem key={orden.orden} value={orden.orden}>
                  {`${orden.orden} - ${orden.cod} - ${orden.cantidad_total} - ${orden.producidos}`}
                </MenuItem>
              ))}
            </TextField> */}
            <TextField
              fullWidth
              select
              variant="outlined"
              size="medium"
              label="Seleccione la Orden"
              name="orden"
              value={formik.values.orden}
              onChange={async (e) => {
                const selectedOrden = e.target.value;
                formik.setFieldValue("orden", selectedOrden);

                // 🔹 Buscar los datos de la orden seleccionada
                const ordenData = ordenes.find(
                  (o) => o.orden === selectedOrden
                );
                console.log("🚀 ~ FormChapas ~ ordenData:", ordenData)
                if (ordenData) {
                  formik.setFieldValue("cod", ordenData.cod || "");
                  formik.setFieldValue("llave", ordenData.id || ""); // 👈 asumo que `id` es la llave
                  formik.setFieldValue("llave_producto", ordenData.llave ?? 0);
                  formik.setFieldValue(
                    "restante",
                    ordenData.cantidad_total - ordenData.producidos || 0
                  );
                  try {
                    // 🔹 Llamar al servicio con el cod
                    const paquete = await getOnePaquetexd(ordenData.cod);
                  } catch (err) {
                    console.error("Error al obtener paquete:", err);
                    toast.error("No se pudo obtener datos del paquete");
                  }
                }
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.orden && Boolean(formik.errors.orden)}
              helperText={formik.touched.orden && formik.errors.orden}
              sx={{ minWidth: "300px", flex: 1 }}
            >
              {ordenes.map((orden) => (
                <MenuItem key={orden.orden} value={orden.orden}>
                  {`${orden.orden} - ${orden.cod} - ${orden.cantidad_total} - ${orden.producidos}`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Paquete */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Código Interno del Paquete"
              name="cod_interno"
              value={formik.values.cod_interno}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.cod_interno && Boolean(formik.errors.cod_interno)
              }
              helperText={
                formik.touched.cod_interno && formik.errors.cod_interno
              }
              sx={{ minWidth: "300px", flex: 1 }} // 👈 fuerza ancho mayor
            />
          </Grid>

          {/* Cantidad */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="Cantidad"
              name="cantidad"
              value={formik.values.cantidad}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.cantidad && Boolean(formik.errors.cantidad)}
              helperText={formik.touched.cantidad && formik.errors.cantidad}
              sx={{ minWidth: "300px", flex: 1 }} // 👈 fuerza ancho mayor
            />
          </Grid>

          {/* Checkboxes de chapas */}
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="chapa1"
                  checked={formik.values.chapa1}
                  onChange={formik.handleChange}
                />
              }
              label="Usar Chapa 1"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="chapa2"
                  checked={formik.values.chapa2}
                  onChange={formik.handleChange}
                />
              }
              label="Usar Chapa 2"
            />
          </Grid>

          {/* Botón */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                color="error"
                variant="contained"
                onClick={() => setOpenConfirmDialog(true)}
                sx={{
                  marginTop: "2vh",
                  height: "6vh",
                  width: isNonMobile ? "auto" : "100%",
                }}
                disabled={isLoading}
              >
                Vaciar Reservas
              </Button>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{
                  background: "#cedc00",
                  marginTop: "2vh",
                  height: "6vh",
                  width: isNonMobile ? "auto" : "100%",
                }}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} /> : "Asignar"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Diálogo de confirmación */}
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
      >
        <DialogTitle>{"¿Confirmar vaciar reservas?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta acción vaciará todas las reservas. ¿Está seguro que desea continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={async () => {
              try {
                if (!formik.values.orden) {
                  toast.error("Debe seleccionar una orden antes de vaciar reservas");
                  return;
                }
                setIsLoading(true);
                await getVaciarChapa(formik.values.orden);
                toast.success("Reservas vaciadas exitosamente");
                
              } catch (error) {
                toast.error("Error al vaciar reservas");
                console.error("Error:", error);
              } finally {
                setIsLoading(false);
                setOpenConfirmDialog(false);
              }
            }}
            color="error"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FormChapas;
